import Glyphicon from './Glyphicon';
export default Glyphicon;